<template>
  <v-card>
    <v-card-text>                                                   
      <html-with-fields-inserted :content="section.questions[type]" :insert-fields="insertFields"/>
      <div v-for="(v, i) in value" :key="i">
        <v-layout row wrap>
          <v-flex xs10>{{i + 1}}</v-flex>
          <v-flex xs10>
            <v-text-field counter :maxlength="section.maxLength" v-model="value[i]"></v-text-field>
          </v-flex>
        </v-layout>
      </div>
      <v-alert :value="error" color="error" icon="warning" outline>{{errorMsg}}</v-alert>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="backPage">Back</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="nextPage">Next</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import HtmlWithFieldsInserted from "@/components/common/htmlWithFieldsInserted.vue";
export default {
  components: {
    HtmlWithFieldsInserted
  },
  props: {
    section: {
      type: Object,
      required: true
    },
    value: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    insertFields: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      error: false,
      errorMsg: "回答は最低3つ以上入力してください。"
    };
  },
  created: function() {
    let v = [];
    for (var i = 1; i <= this.section.maxOfComments; i++) {
      v.push({ id: i, section: "" });
    }
    this.sections = v;
  },
  mounted() {},
  methods: {
    backPage() {
      this.$emit("backStep");
    },
    nextPage() {
      if (this.validate()) {
        this.$emit("nextStep");
      } else {
        this.error = true;
      }
    },
    validate() {
      
      return (
        this.value.filter(v => v.length > 0).length >=
        this.section.minOfComments
      );
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


